var Vendd = (function (Vendd) {
    'use strict';

    Vendd.DeliveryPoint = (function (DeliveryPoint) {

        DeliveryPoint.Messages = (function (Messages) {

            Messages.GetModel = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.GetModel', {});
            };
            Messages.GetModel.className = 'Vendd.DeliveryPoint.Messages.GetModel';

            Messages.GetModelSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.GetModelSuccess', data);
            };
            Messages.GetModelSuccess.className = 'Vendd.DeliveryPoint.Messages.GetModelSuccess';

            Messages.GetModelFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.DeliveryPoint.Messages.GetModelFailed';       

            Messages.ResetStore = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.ResetStore', {});
            };
            Messages.ResetStore.className = 'Vendd.DeliveryPoint.Messages.ResetStore';

            Messages.ResetStoreSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.ResetStoreSuccess', data);
            };
            Messages.ResetStoreSuccess.className = 'Vendd.DeliveryPoint.Messages.ResetStoreSuccess';

            Messages.ResetStoreFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.ResetStoreFailed', response);
            };
            Messages.ResetStoreFailed.className = 'Vendd.DeliveryPoint.Messages.ResetStoreFailed';   

            Messages.ResetDeliveryPoint = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.ResetDeliveryPoint', {});
            };
            Messages.ResetDeliveryPoint.className = 'Vendd.DeliveryPoint.Messages.ResetDeliveryPoint';

            Messages.ResetDeliveryPointSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.ResetDeliveryPointSuccess', data);
            };
            Messages.ResetDeliveryPointSuccess.className = 'Vendd.DeliveryPoint.Messages.ResetDeliveryPointSuccess';

            Messages.ResetDeliveryPointFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.DeliveryPoint.Messages.ResetDeliveryPointFailed', response);
            };
            Messages.ResetDeliveryPointFailed.className = 'Vendd.DeliveryPoint.Messages.ResetDeliveryPointFailed';   

            return Messages;

        })(DeliveryPoint.Messages || {});

        return DeliveryPoint;

    })(Vendd.DeliveryPoint || {});

    return Vendd;

})(Vendd || {});